import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  InputAdornment,
  Chip,
  Tooltip,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Card,
  CardContent,
  Tabs,
  Tab,
  LinearProgress,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Avatar,
} from "@mui/material";
import {
  Search as SearchIcon,
  Add as AddIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  Refresh as RefreshIcon,
  Stars as LoyaltyIcon,
  EmojiEvents as TrophyIcon,
  CardGiftcard as CouponIcon,
  LocalOffer as OfferIcon,
  Person as PersonIcon,
  TrendingUp as PointsIcon,
  Redeem as RedeemIcon,
  Verified as VerifiedIcon,
  Info as InfoIcon,
  MonetizationOn as MoneyIcon,
  CalendarToday as CalendarIcon,
  CheckCircle as CheckIcon,
  Percent as PercentIcon,
  WorkspacePremium as PremiumIcon,
} from "@mui/icons-material";

const LoyaltyProgram = () => {
  const [activeTab, setActiveTab] = useState(0);

  // Sample loyalty members data
  const [loyaltyMembers, setLoyaltyMembers] = useState([
    {
      id: 1,
      customerCode: "CUST001",
      customerName: "Rajesh Kumar",
      membershipNo: "LYL001",
      tier: "Gold",
      totalPoints: 2450,
      lifetimePoints: 5680,
      totalSpent: 245000,
      joinDate: "2023-06-15",
      lastActivity: "2024-01-18",
      status: "Active",
      availableCoupons: 3,
      redeemedRewards: 5,
    },
    {
      id: 2,
      customerCode: "CUST002",
      customerName: "Priya Sharma",
      membershipNo: "LYL002",
      tier: "Platinum",
      totalPoints: 5500,
      lifetimePoints: 12340,
      totalSpent: 550000,
      joinDate: "2023-03-20",
      lastActivity: "2024-01-20",
      status: "Active",
      availableCoupons: 5,
      redeemedRewards: 12,
    },
    {
      id: 3,
      customerCode: "CUST003",
      customerName: "Amit Patel",
      membershipNo: "LYL003",
      tier: "Platinum",
      totalPoints: 8750,
      lifetimePoints: 18920,
      totalSpent: 1250000,
      joinDate: "2023-01-10",
      lastActivity: "2024-01-19",
      status: "Active",
      availableCoupons: 7,
      redeemedRewards: 18,
    },
    {
      id: 4,
      customerCode: "CUST004",
      customerName: "Sneha Desai",
      membershipNo: "LYL004",
      tier: "Silver",
      totalPoints: 1250,
      lifetimePoints: 2890,
      totalSpent: 125000,
      joinDate: "2023-08-05",
      lastActivity: "2024-01-15",
      status: "Active",
      availableCoupons: 2,
      redeemedRewards: 3,
    },
    {
      id: 5,
      customerCode: "CUST005",
      customerName: "Vikram Singh",
      membershipNo: "LYL005",
      tier: "Gold",
      totalPoints: 3200,
      lifetimePoints: 9800,
      totalSpent: 980000,
      joinDate: "2023-02-28",
      lastActivity: "2023-12-10",
      status: "Active",
      availableCoupons: 4,
      redeemedRewards: 8,
    },
  ]);

  // Sample rewards/coupons data
  const [rewards, setRewards] = useState([
    {
      id: 1,
      rewardCode: "RWD001",
      rewardName: "₹500 Off on Next Purchase",
      rewardType: "Discount Coupon",
      pointsCost: 500,
      discountValue: 500,
      discountType: "Fixed",
      minPurchase: 2000,
      validityDays: 30,
      totalIssued: 145,
      totalRedeemed: 98,
      status: "Active",
    },
    {
      id: 2,
      rewardCode: "RWD002",
      rewardName: "10% Off Entire Bill",
      rewardType: "Percentage Discount",
      pointsCost: 300,
      discountValue: 10,
      discountType: "Percentage",
      minPurchase: 1000,
      validityDays: 30,
      totalIssued: 234,
      totalRedeemed: 187,
      status: "Active",
    },
    {
      id: 3,
      rewardCode: "RWD003",
      rewardName: "Free Product - Electronics",
      rewardType: "Free Product",
      pointsCost: 1000,
      discountValue: 0,
      discountType: "Free Item",
      minPurchase: 0,
      validityDays: 60,
      totalIssued: 42,
      totalRedeemed: 28,
      status: "Active",
    },
    {
      id: 4,
      rewardCode: "RWD004",
      rewardName: "₹1000 Gift Voucher",
      rewardType: "Gift Voucher",
      pointsCost: 800,
      discountValue: 1000,
      discountType: "Fixed",
      minPurchase: 5000,
      validityDays: 90,
      totalIssued: 67,
      totalRedeemed: 45,
      status: "Active",
    },
    {
      id: 5,
      rewardCode: "RWD005",
      rewardName: "15% Birthday Special",
      rewardType: "Special Offer",
      pointsCost: 0,
      discountValue: 15,
      discountType: "Percentage",
      minPurchase: 500,
      validityDays: 7,
      totalIssued: 89,
      totalRedeemed: 76,
      status: "Active",
    },
  ]);

  // Sample offers for loyal customers
  const [specialOffers, setSpecialOffers] = useState([
    {
      id: 1,
      offerCode: "OFF001",
      offerName: "Old Customer Appreciation",
      offerType: "Regular Customer",
      description: "Special 20% discount for customers with 2+ years membership",
      eligibilityCriteria: "Membership > 2 years",
      discountValue: 20,
      validFrom: "2024-01-01",
      validTo: "2024-01-31",
      eligibleCustomers: 156,
      usedCount: 87,
      status: "Active",
    },
    {
      id: 2,
      offerCode: "OFF002",
      offerName: "Loyalty Bonus Points",
      offerType: "Points Multiplier",
      description: "2X points on all purchases for Gold & Platinum members",
      eligibilityCriteria: "Tier = Gold OR Platinum",
      discountValue: 0,
      validFrom: "2024-01-15",
      validTo: "2024-02-15",
      eligibleCustomers: 89,
      usedCount: 45,
      status: "Active",
    },
    {
      id: 3,
      offerCode: "OFF003",
      offerName: "VIP Weekend Sale",
      offerType: "Tier Based",
      description: "Exclusive 25% off for Platinum members on weekends",
      eligibilityCriteria: "Tier = Platinum",
      discountValue: 25,
      validFrom: "2024-01-20",
      validTo: "2024-02-20",
      eligibleCustomers: 34,
      usedCount: 18,
      status: "Active",
    },
  ]);

  const [searchQuery, setSearchQuery] = useState("");
  const [tierFilter, setTierFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [successMessage, setSuccessMessage] = useState("");
  const [errors, setErrors] = useState({});

  // Modal state
  const [openRewardModal, setOpenRewardModal] = useState(false);
  const [openOfferModal, setOpenOfferModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openIssueModal, setOpenIssueModal] = useState(false);
  const [editingReward, setEditingReward] = useState(null);
  const [viewingMember, setViewingMember] = useState(null);
  const [selectedMembers, setSelectedMembers] = useState([]);

  // Form state
  const [rewardForm, setRewardForm] = useState({
    rewardCode: "",
    rewardName: "",
    rewardType: "Discount Coupon",
    pointsCost: 0,
    discountValue: 0,
    discountType: "Fixed",
    minPurchase: 0,
    validityDays: 30,
    status: "Active",
  });

  const [offerForm, setOfferForm] = useState({
    offerCode: "",
    offerName: "",
    offerType: "Regular Customer",
    description: "",
    eligibilityCriteria: "",
    discountValue: 0,
    validFrom: new Date().toISOString().split('T')[0],
    validTo: "",
    status: "Active",
  });

  // Helper functions
  const getFilteredMembers = () => {
    return loyaltyMembers.filter((member) => {
      const matchesSearch = Object.values(member).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      );
      const matchesTier = tierFilter === "all" || member.tier === tierFilter;
      const matchesStatus = statusFilter === "all" || member.status === statusFilter;
      return matchesSearch && matchesTier && matchesStatus;
    });
  };

  const getTierColor = (tier) => {
    switch (tier) {
      case 'Platinum': return { bg: '#9c27b0', text: 'white' };
      case 'Gold': return { bg: '#ff9800', text: 'white' };
      case 'Silver': return { bg: '#9e9e9e', text: 'white' };
      case 'Bronze': return { bg: '#795548', text: 'white' };
      default: return { bg: '#1976d2', text: 'white' };
    }
  };

  const getTierIcon = (tier) => {
    switch (tier) {
      case 'Platinum': return <PremiumIcon />;
      case 'Gold': return <TrophyIcon />;
      case 'Silver': return <VerifiedIcon />;
      default: return <LoyaltyIcon />;
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const getPointsToNextTier = (currentPoints, tier) => {
    const tiers = {
      Bronze: 1000,
      Silver: 3000,
      Gold: 6000,
      Platinum: 10000,
    };
    const nextTier = tier === 'Bronze' ? 'Silver' : tier === 'Silver' ? 'Gold' : tier === 'Gold' ? 'Platinum' : null;
    if (!nextTier) return 0;
    return tiers[nextTier] - currentPoints;
  };

  // Handlers
  const handleView = (member) => {
    setViewingMember(member);
    setOpenViewModal(true);
  };

  const handleIssueReward = () => {
    setOpenIssueModal(true);
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearch = () => {
    setPage(0);
    setSuccessMessage(`Search completed. Found ${getFilteredMembers().length} members.`);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleReset = () => {
    setSearchQuery("");
    setTierFilter("all");
    setStatusFilter("all");
    setPage(0);
    setErrors({});
    setSuccessMessage("");
  };

  const handleOpenRewardModal = () => {
    setEditingReward(null);
    const newCode = `RWD${String(rewards.length + 1).padStart(3, '0')}`;
    setRewardForm({
      rewardCode: newCode,
      rewardName: "",
      rewardType: "Discount Coupon",
      pointsCost: 0,
      discountValue: 0,
      discountType: "Fixed",
      minPurchase: 0,
      validityDays: 30,
      status: "Active",
    });
    setOpenRewardModal(true);
  };

  const handleOpenOfferModal = () => {
    const newCode = `OFF${String(specialOffers.length + 1).padStart(3, '0')}`;
    setOfferForm({
      offerCode: newCode,
      offerName: "",
      offerType: "Regular Customer",
      description: "",
      eligibilityCriteria: "",
      discountValue: 0,
      validFrom: new Date().toISOString().split('T')[0],
      validTo: "",
      status: "Active",
    });
    setOpenOfferModal(true);
  };

  const handleSaveReward = () => {
    if (!rewardForm.rewardName) {
      setErrors({ rewardName: "Reward name is required" });
      return;
    }

    const newReward = {
      id: rewards.length + 1,
      ...rewardForm,
      totalIssued: 0,
      totalRedeemed: 0,
    };

    setRewards([newReward, ...rewards]);
    setSuccessMessage("Reward created successfully!");
    setOpenRewardModal(false);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleSaveOffer = () => {
    if (!offerForm.offerName) {
      setErrors({ offerName: "Offer name is required" });
      return;
    }

    const newOffer = {
      id: specialOffers.length + 1,
      ...offerForm,
      eligibleCustomers: 0,
      usedCount: 0,
    };

    setSpecialOffers([newOffer, ...specialOffers]);
    setSuccessMessage("Offer created successfully!");
    setOpenOfferModal(false);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const handleIssueToSelected = () => {
    setSuccessMessage(`Coupons issued to ${selectedMembers.length} customer(s)!`);
    setOpenIssueModal(false);
    setSelectedMembers([]);
    setTimeout(() => setSuccessMessage(""), 3000);
  };

  const filteredMembers = getFilteredMembers();

  // Calculate statistics
  const totalMembers = loyaltyMembers.length;
  const activeMembers = loyaltyMembers.filter(m => m.status === "Active").length;
  const totalPoints = loyaltyMembers.reduce((sum, m) => sum + m.totalPoints, 0);
  const totalRedeemed = rewards.reduce((sum, r) => sum + r.totalRedeemed, 0);
  const platinumMembers = loyaltyMembers.filter(m => m.tier === "Platinum").length;
  const goldMembers = loyaltyMembers.filter(m => m.tier === "Gold").length;

  return (
    <Box sx={{ p: 3 }}>
      {/* Header Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <LoyaltyIcon sx={{ color: 'secondary.main', fontSize: 40 }} />
          <Box>
            <Typography variant="h4" fontWeight="bold" color="primary">
              Loyalty Program
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Reward regular customers with points, coupons & exclusive offers • {filteredMembers.length} members
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="outlined"
            startIcon={<OfferIcon />}
            onClick={handleOpenOfferModal}
            sx={{ borderRadius: 2 }}
          >
            Create Offer
          </Button>
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            onClick={handleOpenRewardModal}
            sx={{
              borderRadius: 2,
              px: 3,
              py: 1,
              fontWeight: 600,
              backgroundColor: 'primary.main',
              '&:hover': {
                backgroundColor: 'primary.dark',
              },
            }}
          >
            Add Reward
          </Button>
        </Box>
      </Box>

      {/* Success Message */}
      {successMessage && (
        <Alert severity="success" sx={{ mb: 2, borderRadius: 2 }}>
          {successMessage}
        </Alert>
      )}

      {/* Statistics Cards */}
      <Grid container spacing={3} sx={{ mb: 3 }}>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #9c27b0' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Total Members</Typography>
                  <Typography variant="h4" fontWeight="bold" color="secondary.main">
                    {totalMembers}
                  </Typography>
                </Box>
                <PersonIcon sx={{ fontSize: 48, color: 'secondary.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #ff9800' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Active Points</Typography>
                  <Typography variant="h6" fontWeight="bold" color="warning.main">
                    {totalPoints.toLocaleString('en-IN')}
                  </Typography>
                </Box>
                <PointsIcon sx={{ fontSize: 48, color: 'warning.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #2e7d32' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Rewards Redeemed</Typography>
                  <Typography variant="h4" fontWeight="bold" color="success.main">
                    {totalRedeemed}
                  </Typography>
                </Box>
                <RedeemIcon sx={{ fontSize: 48, color: 'success.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <Card sx={{ borderRadius: 2, boxShadow: 2, borderLeft: '4px solid #1976d2' }}>
            <CardContent>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Box>
                  <Typography variant="caption" color="text.secondary">Premium Members</Typography>
                  <Typography variant="h5" fontWeight="bold" color="primary.main">
                    {platinumMembers + goldMembers}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {platinumMembers} Platinum • {goldMembers} Gold
                  </Typography>
                </Box>
                <TrophyIcon sx={{ fontSize: 48, color: 'primary.main', opacity: 0.3 }} />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* Tabs */}
      <Paper sx={{ mb: 3, borderRadius: 2 }}>
        <Tabs 
          value={activeTab} 
          onChange={(e, newValue) => setActiveTab(newValue)}
          sx={{ borderBottom: 1, borderColor: 'divider' }}
        >
          <Tab label="Loyalty Members" icon={<PersonIcon />} iconPosition="start" />
          <Tab label="Rewards Catalog" icon={<CouponIcon />} iconPosition="start" />
          <Tab label="Special Offers" icon={<OfferIcon />} iconPosition="start" />
        </Tabs>
      </Paper>

      {/* Tab 0: Loyalty Members */}
      {activeTab === 0 && (
        <>
          {/* Search and Filter */}
          <Paper sx={{ p: 3, mb: 3, borderRadius: 2, boxShadow: 2 }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  label="Search Members..."
                  variant="outlined"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  select
                  fullWidth
                  label="Tier"
                  value={tierFilter}
                  onChange={(e) => setTierFilter(e.target.value)}
                  SelectProps={{ native: true }}
                >
                  <option value="all">All Tiers</option>
                  <option value="Platinum">Platinum</option>
                  <option value="Gold">Gold</option>
                  <option value="Silver">Silver</option>
                  <option value="Bronze">Bronze</option>
                </TextField>
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  select
                  fullWidth
                  label="Status"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                  SelectProps={{ native: true }}
                >
                  <option value="all">All Status</option>
                  <option value="Active">Active</option>
                  <option value="Inactive">Inactive</option>
                </TextField>
              </Grid>
              <Grid item xs={12} md={4}>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Button variant="contained" onClick={handleSearch} startIcon={<SearchIcon />} sx={{ flex: 1 }}>
                    Search
                  </Button>
                  <Button variant="outlined" onClick={handleReset} startIcon={<RefreshIcon />} sx={{ flex: 1 }}>
                    Reset
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </Paper>

          {/* Members Table */}
          <Paper sx={{ borderRadius: 2, boxShadow: 3, overflow: 'hidden' }}>
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f8f9fa' }}>
                    <TableCell sx={{ fontWeight: 'bold' }}>Member</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Tier</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Points</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Total Spent</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Coupons</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Member Since</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }}>Status</TableCell>
                    <TableCell sx={{ fontWeight: 'bold' }} align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredMembers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((member) => {
                    const tierStyle = getTierColor(member.tier);
                    return (
                      <TableRow key={member.id} sx={{ '&:hover': { backgroundColor: '#f5f5f5' } }}>
                        <TableCell>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Avatar sx={{ bgcolor: tierStyle.bg, width: 32, height: 32 }}>
                              {getTierIcon(member.tier)}
                            </Avatar>
                            <Box>
                              <Typography variant="body2" fontWeight="600">{member.customerName}</Typography>
                              <Typography variant="caption" color="text.secondary">{member.membershipNo}</Typography>
                            </Box>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Chip 
                            label={member.tier} 
                            size="small"
                            sx={{ bgcolor: tierStyle.bg, color: tierStyle.text, fontWeight: 600 }}
                          />
                        </TableCell>
                        <TableCell>
                          <Box>
                            <Typography variant="body2" fontWeight="700" color="warning.main">
                              {member.totalPoints.toLocaleString('en-IN')}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                              Lifetime: {member.lifetimePoints.toLocaleString('en-IN')}
                            </Typography>
                          </Box>
                        </TableCell>
                        <TableCell>
                          <Typography variant="body2" fontWeight="600" color="primary.main">
                            {formatCurrency(member.totalSpent)}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Chip 
                            icon={<CouponIcon />}
                            label={member.availableCoupons}
                            size="small"
                            color="success"
                          />
                        </TableCell>
                        <TableCell>
                          <Typography variant="caption">{member.joinDate}</Typography>
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={member.status}
                            size="small"
                            sx={{
                              backgroundColor: member.status === 'Active' ? '#e8f5e9' : '#ffebee',
                              color: member.status === 'Active' ? '#2e7d32' : '#d32f2f',
                              fontWeight: 600,
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                            <Tooltip title="View Details">
                              <IconButton size="small" onClick={() => handleView(member)} sx={{ color: 'info.main' }}>
                                <ViewIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Issue Coupon">
                              <IconButton size="small" sx={{ color: 'success.main' }}>
                                <CouponIcon fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={filteredMembers.length}
              page={page}
              onPageChange={handleChangePage}
              rowsPerPage={rowsPerPage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              rowsPerPageOptions={[5, 10, 25]}
            />
          </Paper>
        </>
      )}

      {/* Tab 1: Rewards Catalog */}
      {activeTab === 1 && (
        <Grid container spacing={3}>
          {rewards.map((reward) => (
            <Grid item xs={12} sm={6} md={4} key={reward.id}>
              <Card sx={{ borderRadius: 2, boxShadow: 2, height: '100%' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Chip 
                      label={reward.rewardType} 
                      size="small" 
                      color="primary"
                      sx={{ fontWeight: 600 }}
                    />
                    <Chip 
                      label={reward.status} 
                      size="small" 
                      color="success"
                    />
                  </Box>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {reward.rewardName}
                  </Typography>
                  <Box sx={{ my: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="body2" color="text.secondary">Points Required:</Typography>
                      <Typography variant="body2" fontWeight="700" color="warning.main">
                        {reward.pointsCost} pts
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="body2" color="text.secondary">Discount:</Typography>
                      <Typography variant="body2" fontWeight="700" color="success.main">
                        {reward.discountType === 'Percentage' ? `${reward.discountValue}%` : formatCurrency(reward.discountValue)}
                      </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="body2" color="text.secondary">Min Purchase:</Typography>
                      <Typography variant="body2">{formatCurrency(reward.minPurchase)}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                      <Typography variant="body2" color="text.secondary">Validity:</Typography>
                      <Typography variant="body2">{reward.validityDays} days</Typography>
                    </Box>
                  </Box>
                  <Divider sx={{ my: 2 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="caption" color="text.secondary">Issued: {reward.totalIssued}</Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ ml: 2 }}>Redeemed: {reward.totalRedeemed}</Typography>
                    </Box>
                    <LinearProgress 
                      variant="determinate" 
                      value={(reward.totalRedeemed / reward.totalIssued) * 100 || 0}
                      sx={{ width: 60, height: 6, borderRadius: 1 }}
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Tab 2: Special Offers */}
      {activeTab === 2 && (
        <Grid container spacing={3}>
          {specialOffers.map((offer) => (
            <Grid item xs={12} md={6} key={offer.id}>
              <Card sx={{ borderRadius: 2, boxShadow: 2 }}>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                    <Chip label={offer.offerType} size="small" color="secondary" />
                    <Chip label={offer.status} size="small" color="success" />
                  </Box>
                  <Typography variant="h6" fontWeight="bold" gutterBottom>
                    {offer.offerName}
                  </Typography>
                  <Typography variant="body2" color="text.secondary" paragraph>
                    {offer.description}
                  </Typography>
                  <Box sx={{ bgcolor: '#f5f5f5', p: 2, borderRadius: 1, mb: 2 }}>
                    <Typography variant="caption" color="text.secondary">Eligibility:</Typography>
                    <Typography variant="body2" fontWeight="600">
                      {offer.eligibilityCriteria}
                    </Typography>
                  </Box>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Discount:</Typography>
                      <Typography variant="h6" fontWeight="bold" color="success.main">
                        {offer.discountValue}%
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Eligible Customers:</Typography>
                      <Typography variant="h6" fontWeight="bold" color="primary.main">
                        {offer.eligibleCustomers}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Valid From:</Typography>
                      <Typography variant="body2">{offer.validFrom}</Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="caption" color="text.secondary">Valid To:</Typography>
                      <Typography variant="body2">{offer.validTo}</Typography>
                    </Grid>
                  </Grid>
                  <Divider sx={{ my: 2 }} />
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="body2" color="text.secondary">
                      Used: {offer.usedCount} / {offer.eligibleCustomers}
                    </Typography>
                    <LinearProgress 
                      variant="determinate" 
                      value={(offer.usedCount / offer.eligibleCustomers) * 100 || 0}
                      sx={{ width: 100, height: 6, borderRadius: 1 }}
                      color="success"
                    />
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}

      {/* Add Reward Modal */}
      <Dialog open={openRewardModal} onClose={() => setOpenRewardModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
        }}>
          <Typography variant="h6" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <CouponIcon /> Add New Reward
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField fullWidth label="Reward Code" value={rewardForm.rewardCode} disabled />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                fullWidth 
                label="Reward Name *" 
                value={rewardForm.rewardName}
                onChange={(e) => setRewardForm({...rewardForm, rewardName: e.target.value})}
                error={!!errors.rewardName}
                helperText={errors.rewardName}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Reward Type</InputLabel>
                <Select 
                  value={rewardForm.rewardType}
                  onChange={(e) => setRewardForm({...rewardForm, rewardType: e.target.value})}
                  label="Reward Type"
                >
                  <MenuItem value="Discount Coupon">Discount Coupon</MenuItem>
                  <MenuItem value="Percentage Discount">Percentage Discount</MenuItem>
                  <MenuItem value="Free Product">Free Product</MenuItem>
                  <MenuItem value="Gift Voucher">Gift Voucher</MenuItem>
                  <MenuItem value="Special Offer">Special Offer</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField 
                fullWidth 
                type="number" 
                label="Points Cost"
                value={rewardForm.pointsCost}
                onChange={(e) => setRewardForm({...rewardForm, pointsCost: parseInt(e.target.value)})}
                InputProps={{ startAdornment: <InputAdornment position="start"><PointsIcon /></InputAdornment> }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField 
                fullWidth 
                type="number" 
                label="Discount Value"
                value={rewardForm.discountValue}
                onChange={(e) => setRewardForm({...rewardForm, discountValue: parseFloat(e.target.value)})}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Discount Type</InputLabel>
                <Select 
                  value={rewardForm.discountType}
                  onChange={(e) => setRewardForm({...rewardForm, discountType: e.target.value})}
                  label="Discount Type"
                >
                  <MenuItem value="Fixed">Fixed Amount</MenuItem>
                  <MenuItem value="Percentage">Percentage</MenuItem>
                  <MenuItem value="Free Item">Free Item</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField 
                fullWidth 
                type="number" 
                label="Min Purchase Amount"
                value={rewardForm.minPurchase}
                onChange={(e) => setRewardForm({...rewardForm, minPurchase: parseFloat(e.target.value)})}
                InputProps={{ startAdornment: <InputAdornment position="start">₹</InputAdornment> }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField 
                fullWidth 
                type="number" 
                label="Validity (Days)"
                value={rewardForm.validityDays}
                onChange={(e) => setRewardForm({...rewardForm, validityDays: parseInt(e.target.value)})}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button onClick={() => setOpenRewardModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveReward}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': { backgroundColor: 'primary.dark' },
            }}
          >
            Create Reward
          </Button>
        </DialogActions>
      </Dialog>

      {/* Add Offer Modal */}
      <Dialog open={openOfferModal} onClose={() => setOpenOfferModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
        }}>
          <Typography variant="h6" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <OfferIcon /> Create Special Offer
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Offer Code" value={offerForm.offerCode} disabled />
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <InputLabel>Offer Type</InputLabel>
                <Select 
                  value={offerForm.offerType}
                  onChange={(e) => setOfferForm({...offerForm, offerType: e.target.value})}
                  label="Offer Type"
                >
                  <MenuItem value="Regular Customer">Regular Customer</MenuItem>
                  <MenuItem value="Points Multiplier">Points Multiplier</MenuItem>
                  <MenuItem value="Tier Based">Tier Based</MenuItem>
                  <MenuItem value="Birthday Special">Birthday Special</MenuItem>
                  <MenuItem value="Anniversary">Anniversary</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <TextField 
                fullWidth 
                label="Offer Name *"
                value={offerForm.offerName}
                onChange={(e) => setOfferForm({...offerForm, offerName: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                fullWidth 
                multiline 
                rows={2}
                label="Description"
                value={offerForm.description}
                onChange={(e) => setOfferForm({...offerForm, description: e.target.value})}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                fullWidth 
                label="Eligibility Criteria"
                value={offerForm.eligibilityCriteria}
                onChange={(e) => setOfferForm({...offerForm, eligibilityCriteria: e.target.value})}
                placeholder="e.g., Membership > 2 years"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField 
                fullWidth 
                type="number"
                label="Discount %"
                value={offerForm.discountValue}
                onChange={(e) => setOfferForm({...offerForm, discountValue: parseFloat(e.target.value)})}
                InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField 
                fullWidth 
                type="date"
                label="Valid From"
                value={offerForm.validFrom}
                onChange={(e) => setOfferForm({...offerForm, validFrom: e.target.value})}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField 
                fullWidth 
                type="date"
                label="Valid To"
                value={offerForm.validTo}
                onChange={(e) => setOfferForm({...offerForm, validTo: e.target.value})}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ p: 2.5, gap: 1 }}>
          <Button onClick={() => setOpenOfferModal(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveOffer}
            sx={{
              backgroundColor: 'primary.main',
              '&:hover': { backgroundColor: 'primary.dark' },
            }}
          >
            Create Offer
          </Button>
        </DialogActions>
      </Dialog>

      {/* View Member Modal */}
      <Dialog open={openViewModal} onClose={() => setOpenViewModal(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{
          backgroundColor: 'primary.main',
          color: 'white',
        }}>
          <Typography variant="h6" sx={{ color: 'white', display: 'flex', alignItems: 'center', gap: 1 }}>
            <InfoIcon /> Member Details
          </Typography>
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          {viewingMember && (
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                  <Avatar sx={{ bgcolor: getTierColor(viewingMember.tier).bg, width: 56, height: 56 }}>
                    {getTierIcon(viewingMember.tier)}
                  </Avatar>
                  <Box>
                    <Typography variant="h6" fontWeight="bold">{viewingMember.customerName}</Typography>
                    <Chip label={viewingMember.tier} size="small" sx={{ bgcolor: getTierColor(viewingMember.tier).bg, color: 'white', fontWeight: 600 }} />
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(255, 152, 0, 0.1)' }}>
                  <Typography variant="caption">Current Points</Typography>
                  <Typography variant="h4" fontWeight="bold" color="warning.main">{viewingMember.totalPoints.toLocaleString('en-IN')}</Typography>
                  <Typography variant="caption" color="text.secondary">Lifetime: {viewingMember.lifetimePoints.toLocaleString('en-IN')} pts</Typography>
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption">Total Spent</Typography>
                  <Typography variant="h6" fontWeight="bold" color="primary.main">{formatCurrency(viewingMember.totalSpent)}</Typography>
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(76, 175, 80, 0.05)' }}>
                  <Typography variant="caption">Coupons</Typography>
                  <Typography variant="h6" fontWeight="bold" color="success.main">{viewingMember.availableCoupons}</Typography>
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(156, 39, 176, 0.05)' }}>
                  <Typography variant="caption">Rewards Redeemed</Typography>
                  <Typography variant="h6" fontWeight="bold" color="secondary.main">{viewingMember.redeemedRewards}</Typography>
                </Paper>
              </Grid>
              <Grid item xs={6}>
                <Paper sx={{ p: 2, bgcolor: 'rgba(83, 109, 254, 0.05)' }}>
                  <Typography variant="caption">Member Since</Typography>
                  <Typography variant="body2" fontWeight="bold">{viewingMember.joinDate}</Typography>
                </Paper>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2.5 }}>
          <Button onClick={() => setOpenViewModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default LoyaltyProgram;

